import apiClient from "../config/axiosConfig";
import { useAppSelector } from "../config/hooks";
import { PostDailyReport } from "../models/employee.model";
import {
  Attendance,
  AttendanceFilter,
  FilterDataForConsolidateView,
  GetDailyReport,
  Regularization,
  RegularizeFilter,
  Timesheet,
  UpdateTimesheetRequest,
  WeeklyTimesheetAproveRequest,
  WeeklyTimesheetRequest,
} from "../slices/attendanceSlice";
import {
  ApplyLeaveRequest,
  GetLeaveBalance,
  GetLeaveRequestFilter,
  UpdateLeaveBalance,
} from "../slices/leaveSlice";

class AttendanceService {
  postAttedance(req: Attendance) {
    return apiClient.post(`/v1/exo/attendance`, req);
  }

  getAllAttendance(req: AttendanceFilter) {
    return apiClient.get(`/v1/exo/attendance?`, {
      params: req,
    });
  }

  getAllEmployeeAttendance(req: AttendanceFilter) {
    return apiClient.get(`/v1/exo/attendance?`, {
      params: req,
    });
  }

  getAllRegularizeRequest(req: RegularizeFilter) {
    return apiClient.get(`/v1/exo/regularization?`, {
      params: req,
    });
  }

  updateRegularization(req: Regularization) {
    return apiClient.put(`/v1/exo/regularization/${req.regularizationId}`, req);
  }

  updateOutTime(req: Attendance) {
    return apiClient.put(`/v1/exo/attendance/${req.attendanceId}`, req);
  }

  postDailyReport(req: PostDailyReport) {
    return apiClient.post(`/v1/exo/daily-reports`, req);
  }

  getDailyReport(data: GetDailyReport) {
    return apiClient.get(`/v1/exo/daily-reports?employeeId=${data.employeeId}`);
  }

  regularizeRequest(data: Regularization) {
    return apiClient.post(`/v1/exo/regularization`, data);
  }

  getTimesheet(data: AttendanceFilter) {
    return apiClient.get(`/v1/exo/timesheets?`, {
      params: data,
    });
  }

  getConsolidateView(data: FilterDataForConsolidateView) {
    return apiClient.get(`/v1/exo/consolidated-view?`, {
      params: data,
    });
  }

  getLeaveRequest(data: GetLeaveRequestFilter) {
    return apiClient.get(`/v1/exo/leaves?`, {
      params: data,
    });
  }

  applyLeave(data: ApplyLeaveRequest) {
    return apiClient.post(`/v1/exo/leaves`, data);
  }

  updateLeaveRequest(data: ApplyLeaveRequest) {
    return apiClient.put(`/v1/exo/leaves/${data.id}`, data);
  }

  updateLeaveBalance(data: UpdateLeaveBalance) {
    return apiClient.post(`/v1/exo/leaves/balance`, data);
  }

  editLeaveBalance(data: UpdateLeaveBalance) {
    return apiClient.put(`/v1/exo/leaves/balance/${data.id}`, data);
  }

  getLeaveBalance(data: GetLeaveBalance) {
    return apiClient.get(`/v1/exo/leaves/balance?`, {
      params: data,
    });
  }

  submitWeeklyTimesheet(data: { employeeId: string; date: string }) {
    return apiClient.post(
      `/v1/exo/weekly-approvals/employee/${data.employeeId}`,
      data
    );
  }

  getWeeklyTimesheet(data: WeeklyTimesheetRequest) {
    return apiClient.get(`/v1/exo/weekly-approvals?`, {
      params: data,
    });
  }

  updateWeeklyTimesheet(data: WeeklyTimesheetAproveRequest) {
    return apiClient.put(`/v1/exo/weekly-approvals/${data.id}`, data);
  }

  updateTimesheet(data: UpdateTimesheetRequest) {
    return apiClient.put(`/v1/exo/attendance/${data.id}`, data);
  }
}

const attendanceService = new AttendanceService();
export default attendanceService;
